export const CONFIRM = 'CONFIRM';
export const WITH_COUNTDOWN = 'WITH_COUNTDOWN';
export const INFO = 'INFO';
export const PROMPT_USER_FOR_VALUE = 'PROMPT_USER_FOR_VALUE';
export const RENDER_PROPS = 'RENDER_PROPS';
export const PROGRESS = 'PROGRESS';
export const CUSTOM = 'CUSTOM';
